import React from 'react';
import { Send, Clock, Paperclip, Trash2, Edit } from 'lucide-react';
import { StatusBadge } from '../components/StatusBadge';
export function Outbox() {
  const emails = [{
    id: 1,
    to: 'ap_claims@dollargeneral.com',
    subject: 'Dispute - PO# 12345 - Shortage Claim',
    amount: '$500.00',
    attachments: 2,
    status: 'ready'
  }, {
    id: 2,
    to: 'vendor_support@walmart.com',
    subject: 'Dispute - PO# WM-9921 - Pricing Error',
    amount: '$1,250.00',
    attachments: 3,
    status: 'ready'
  }, {
    id: 3,
    to: 'ap@target.com',
    subject: 'Dispute - PO# TGT-8812 - Shortage',
    amount: '$320.00',
    attachments: 2,
    status: 'scheduled',
    time: 'Tomorrow, 9:00 AM'
  }, {
    id: 4,
    to: 'ap_claims@dollargeneral.com',
    subject: 'Dispute - PO# 12346 - Shortage Claim',
    amount: '$150.00',
    attachments: 2,
    status: 'ready'
  }, {
    id: 5,
    to: 'ap_claims@dollargeneral.com',
    subject: 'Dispute - PO# 12347 - Shortage Claim',
    amount: '$800.00',
    attachments: 2,
    status: 'ready'
  }];
  return <div className="space-y-6" data-id="element-528">
      <div className="flex items-center justify-between" data-id="element-529">
        <div data-id="element-530">
          <h2 className="text-2xl font-bold text-slate-900 tracking-tight" data-id="element-531">
            Outbox
          </h2>
          <p className="text-slate-500 mt-1" data-id="element-532">Review and send dispute emails.</p>
        </div>
        <div className="flex space-x-3" data-id="element-533">
          <button className="px-4 py-2 bg-white border border-slate-300 rounded-lg text-sm font-medium text-slate-700 hover:bg-slate-50 flex items-center space-x-2" data-id="element-534">
            <Clock className="w-4 h-4" data-id="element-535" />
            <span data-id="element-536">Schedule All</span>
          </button>
          <button className="px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 shadow-sm flex items-center space-x-2" data-id="element-537">
            <Send className="w-4 h-4" data-id="element-538" />
            <span data-id="element-539">Send All (5)</span>
          </button>
        </div>
      </div>

      <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden" data-id="element-540">
        <div className="overflow-x-auto" data-id="element-541">
          <table className="w-full text-sm text-left" data-id="element-542">
            <thead className="bg-slate-50 text-slate-500 font-medium" data-id="element-543">
              <tr data-id="element-544">
                <th className="px-6 py-3 w-8" data-id="element-545">
                  <input type="checkbox" className="rounded border-slate-300 text-blue-600 focus:ring-blue-500" data-id="element-546" />
                </th>
                <th className="px-6 py-3" data-id="element-547">Recipient / Subject</th>
                <th className="px-6 py-3" data-id="element-548">Amount</th>
                <th className="px-6 py-3" data-id="element-549">Attachments</th>
                <th className="px-6 py-3" data-id="element-550">Status</th>
                <th className="px-6 py-3 text-right" data-id="element-551">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-552">
              {emails.map(email => <tr key={email.id} className="hover:bg-slate-50 transition-colors group" data-id="element-553">
                  <td className="px-6 py-4" data-id="element-554">
                    <input type="checkbox" className="rounded border-slate-300 text-blue-600 focus:ring-blue-500" data-id="element-555" />
                  </td>
                  <td className="px-6 py-4" data-id="element-556">
                    <div className="font-medium text-slate-900" data-id="element-557">{email.to}</div>
                    <div className="text-xs text-slate-500" data-id="element-558">
                      {email.subject}
                    </div>
                  </td>
                  <td className="px-6 py-4 font-medium text-slate-900" data-id="element-559">
                    {email.amount}
                  </td>
                  <td className="px-6 py-4" data-id="element-560">
                    <div className="flex items-center text-slate-500 text-xs" data-id="element-561">
                      <Paperclip className="w-3 h-3 mr-1" data-id="element-562" />
                      {email.attachments} files
                    </div>
                  </td>
                  <td className="px-6 py-4" data-id="element-563">
                    {email.status === 'scheduled' ? <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-50 text-blue-700 border border-blue-100" data-id="element-564">
                        <Clock className="w-3 h-3 mr-1" data-id="element-565" />
                        {email.time}
                      </span> : <StatusBadge status="neutral" data-id="element-566">Ready to Send</StatusBadge>}
                  </td>
                  <td className="px-6 py-4 text-right" data-id="element-567">
                    <div className="flex items-center justify-end space-x-2 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-568">
                      <button className="p-1.5 hover:bg-slate-200 rounded text-slate-500 hover:text-slate-700" data-id="element-569">
                        <Edit className="w-4 h-4" data-id="element-570" />
                      </button>
                      <button className="p-1.5 hover:bg-rose-100 rounded text-slate-500 hover:text-rose-600" data-id="element-571">
                        <Trash2 className="w-4 h-4" data-id="element-572" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}